import React from 'react';
/**
 * Centered page title + subtitle for Thresholds / Hit Levels.
 */
export function PageHeader() {
  return <div className="text-center mb-10" data-id="element-922">
      <h1 className="text-3xl md:text-4xl font-black text-gray-900 uppercase tracking-tight mb-3" data-id="element-923">
        Thresholds / Hit Levels
      </h1>
      <p className="text-lg text-gray-600 uppercase tracking-wide font-medium" data-id="element-924">
        DAEDO - EP SYSTEM, SIZE & LEVEL
      </p>
    </div>;
}